// extracted by mini-css-extract-plugin
export default {"button":"RoundedButtonExpandedMobile_button__s8UUO"};